<template>
<div :class="$style.wrapper">

    <div :class="$style.toggle">
        <label>
            <span :class="[$style.label, $style.left, {[$style.selected]:english}, {selected:english}]">EN</span>
            <input type="checkbox" v-model='english' @change="languageChanged"/>
            <span :class="['tick', $style.tick, {[$style.left]:english}, {[$style.right]:!english}]">
                <div :class="[$style.dot, 'dot']"/>
            </span>
            <span :class="[$style.label, $style.right, {[$style.selected]:!english}, {selected:!english}]">FR</span>
        </label>
    </div>

</div>
</template>

<script>
export default {
    name: "language",
    mounted: function(){
        this.init();
    },
    props: ['initial'],
    data: function(){
        return {
            english: true
        }
    },
    methods: {
        init: function(){
            this.english = this.initial == 'en';
        },
        languageChanged() {
            var lang = this.english ? 'en' : 'fr';
            this.$emit('language', lang);
        }
    },
    watch: {
        initial: function(value) {
            this.english = value == 'en';
        }
    }
}
</script>

<style module>
.wrapper {
    position: relative;
    /*border: 1px solid black;*/
    font-size: 0.8em;
}
.toggle{
    display: inline-block;
    /* transform: translateY(5px) */
}

.toggle label{
    position: relative;
    display: block;
    border: 1.5px solid #2c3e50;
    width: 50px;
    height: 18px;
    border-radius: 20px;
}

.toggle input{
    display: none;
}

.tick{
    display: inline-block;
    position: absolute;
    width: 50%;
    height: 99%;
    background-color: darkslategrey;
    transition: .2s;
    left: 25%;
    top: 0px;
}

.tick.left{
    border-top-left-radius: 25px;
    border-bottom-left-radius: 25px;
    transform: translateX(-47%) translateY(0%);
}

.tick.right{
    border-top-right-radius: 25px;
    border-bottom-right-radius: 25px;
    transform: translateX(47%) translateY(0%);
}

.dot{
    width: 5px;
    height: 5px;
    border-radius: 5px;
    background-color: white;
    position: relative;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);

}

.label{
    position: absolute;
    transform: translateY(0px);
    transition: 0.3s;
    font-weight: 400;
    font-size: 1.2em;
}

.label.left{
    left: -25px;
}

.label.right{
    right: -25px;
}

.label.selected{
    font-weight: 800;
    color: darkslategrey;
    transition: 0.3s;
}
</style>

<style lang="scss">
@import "@/_variables.scss";

.lexus .selected{
    color: $lexus !important;    
}
.lexus .tick{
    background-color: $lexus !important;
}
.lexus .dot{
    // background-color: silver;
}


.toyota .tick{
    background-color: $toyota !important;    
}

.toyota .selected{
    color: $toyota !important;    
}
</style>